<template>
    <div
        :style="tagStyles"
        :class="[{'redesign-tag--animated': animated, 'bg-gray-100' : !outline }, paddingClasses]"
        class="redesign-tag text-xs flex items-center"
    >
        <div
            v-for="(content, index) in tagContent"
            :key="index"
            :class="{'gap-1': !index}"
            class="redesign-tag__content-item flex items-center"
        >
                <redesign-base-icon
                    v-if="content.iconName"
                    class="redesign-tag__icon"
                    :name="content.iconName"
                    :fill="'transparent'"
                />
            <div v-if="content.text" class="redesign-tag__text text-center" style="font-variant-numeric: tabular-nums;">
                {{ content.text }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import RedesignBaseIcon from "@/components/RedesignBaseComponents/RedesignBaseIcon.vue";
const hexOpacity = '19'

const props = defineProps({
    color: {
        type: String,
        default: ''
    },
    outline: {
        type: Boolean,
        default: false
    },
    paddingClasses: {
        type: String,
        default: 'p-1'
    },
    borderColor: {
        type: String,
        default: ''
    },
    tagContent: {
        type: Array,
        default: () => ([])
    },
    animated: {
      type: Boolean,
      default: false,
    }
});

const tagStyles = computed(() => {
    const styles = {}
    if (props.color) {
        styles.color = props.color
    }
    if (props.color && !props.outline) {
        styles['--dynamicBackgroundColor'] = props.color + hexOpacity
        styles.backgroundColor = 'var(--dynamicBackgroundColor)';
        styles.borderColor = 'transparent'

    }
    if (props.outline && !props.borderColor) {
        styles.borderColor = props.color + hexOpacity
    }
    if (props.borderColor) {
        styles.borderColor = props.borderColor
    }
    return styles
})

</script>

<style scoped lang="scss">
.redesign-tag {
    @apply w-max relative uppercase;
    border-color: var(--gray-200);
    border-width: 1px;
    color: var(--mainTextColor-color);
    min-width: 10px;
    border-radius: 1rem;

    &__text {
        line-height: normal;
    }
    &--animated {
        animation: BlinkerBackground 2s infinite;
      .redesign-tag__icon {
        animation: BlinkerIcon 2s infinite;
      }
    }


    &__content-item {
        @apply relative;
        opacity: 1;

        &:not(:last-child) {
            margin-right: 13px;
        }

        &:not(:last-child)::after {
            @apply absolute top-1/2;
            content: '';
            right: -7px;
            width: 2px;
            height: 2px;
            border-radius: 50%;
            background: var(--mainTextColor-color);
        }
    }
}

@keyframes BlinkerBackground {
    0% {
        background-color: var(--dynamicBackgroundColor);
    }
    50% {
        background-color: transparent;
    }
    100% {
        background-color: var(--dynamicBackgroundColor);
    }
}

@keyframes BlinkerIcon {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
    100% {
        opacity: 1;
    }
}
</style>
